"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isServer = void 0;

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var o = !1;
exports.isServer = o;